import * as React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { useTheme } from '@mui/material/styles'

export const DraggableTableHeaderCell = (id: string, index: number) => {
  const DraggableCell = (props: any) => {
    const theme = useTheme()

    return (
      <Draggable draggableId={id} index={index}>
        {(provided, snapshot) => {
          const style: React.CSSProperties = {
            ...provided.draggableProps.style,
            backgroundColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[800]
                : theme.palette.grey[200],
            borderBottom: 'none',
            fontWeight: 'bold',
          }
          if (snapshot.isDragging) {
            style.border = '1px solid rgba(224, 224, 224, 1)'
          }
          return (
            <th
              {...props}
              ref={provided.innerRef}
              {...provided.dragHandleProps}
              {...provided.draggableProps}
              style={style}
            >
              {props.children}
            </th>
          )
        }}
      </Draggable>
    )
  }

  return DraggableCell
}
